import React from 'react';
import { Link } from 'react-router-dom';
// import logout from '../Components/Image/logout.png'
// import Sidebar from '../Components/Sidebar';
import { Button, Table, InputGroup, Form, FormControl } from 'react-bootstrap';
import { connect } from 'react-redux'
import { getPODetails, getPOSearch, postClaimPO, postUnClaimPO, getSearchedPO, GetExcellExportData, getProjectAllocationByUserId, getQAActivity } from '../store/actions/poDetailsActions'
import { GetFilterList } from '../store/actions/masterActions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AuthHandlerInstance from '../Classes/AuthHandler'
import SearchBar from '../Components/SearchBar';
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import swal from '@sweetalert/with-react'
// import Pagination from 'react-bootstrap/Pagination'
import authInstance from '../Classes/AuthHandler';
import Select from "react-select"
import Loading from '../Components/Loader';
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'
import PaginationComponent from '../Components/PaginationComponent'
import formatTime from '../Classes/FormatTime';
// import { CSVLink } from "react-csv";

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.dateformate = this.dateformate.bind(this);
        this.state = {
            userId: AuthHandlerInstance.getUserID(),
            employee: AuthHandlerInstance.getUserPayLoad(),
            roles: AuthHandlerInstance.getRoles(),
            modal: false,
            selectedItem: {},
            searchTerm: new URLSearchParams(this.props.location.search).get("searchTerm") ? new URLSearchParams(this.props.location.search).get("searchTerm") : "",
            unClaimModal: false,
            loading: false,
            isShowFilter: false,
            isShowPoDocDate: false,
            isShowDCDate: false,
            isShowStatDeliverDate: false,
            tableData: [],
            finalplantcode: [],
            finalemployees: [],
            finalvendorlist: [],
            finalSupplierCategory: [],
            finalpos: [],
            finalwbsno: [],
            finalloc: [],
            sortBy: new URLSearchParams(this.props.location.search).get("sortBy") ? new URLSearchParams(this.props.location.search).get("sortBy") : "all",
            sortByPo: new URLSearchParams(this.props.location.search).get("sortByPo") ? (new URLSearchParams(this.props.location.search).get("sortByPo")).split(',') : [],
            sortByLoc: "",
            poDocStartDate: new URLSearchParams(this.props.location.search).get("poDocStartDate") ? new URLSearchParams(this.props.location.search).get("poDocStartDate") : "",
            poDocEndDate: new URLSearchParams(this.props.location.search).get("poDocEndDate") ? new URLSearchParams(this.props.location.search).get("poDocEndDate") : "",
            latestDcStartDate: '',
            latestDcEndDate: '',
            statDeliveryStartDate: '',
            statDeliveryEndDate: '',
            drgApprovalStartDate: '',
            drgApprovalEndDate: '',
            sortByPODocDate: [],
            sortByWBS: new URLSearchParams(this.props.location.search).get("sortByWBS") ? (new URLSearchParams(this.props.location.search).get("sortByWBS")).split(',') : [],
            sortByPlantCode: new URLSearchParams(this.props.location.search).get("sortByPlantCode") ? (new URLSearchParams(this.props.location.search).get("sortByPlantCode")).split(',') : [],
            sortByEmployees: new URLSearchParams(this.props.location.search).get("sortByEmployees") ? (new URLSearchParams(this.props.location.search).get("sortByEmployees")).split(',') : [],
            sortBySupplierCategory: new URLSearchParams(this.props.location.search).get("sortBySupplierCategory") ? (new URLSearchParams(this.props.location.search).get("sortBySupplierCategory")).split(',') : [],
            sortByStatus: "",
            sortByVendor: new URLSearchParams(this.props.location.search).get("sortByVendor") ? (new URLSearchParams(this.props.location.search).get("sortByVendor")).split(',') : [],
            currentPage: new URLSearchParams(this.props.location.search).get("currentPage") ? new URLSearchParams(this.props.location.search).get("currentPage") : 1,
            totalPos: 0,
            posPerpage: new URLSearchParams(this.props.location.search).get("posPerpage") ? new URLSearchParams(this.props.location.search).get("posPerpage") : 10,
            searchForOptions: [
                {
                    label: 'Currency', value: 'Currency'
                },
                {
                    label: 'Location', value: 'Location'
                },
                {
                    label: 'Material', value: 'Material'
                },
                {
                    label: 'Payment term', value: 'Payment term'
                },
                {
                    label: 'Planner', value: 'Planner'
                },
                {
                    label: 'Plant Code', value: 'Plant Code'
                },
                {
                    label: 'PO Number', value: 'PO Number'
                },
                {
                    label: 'Purchase Group', value: 'Purchase Group'
                },
                {
                    label: 'Vendor', value: 'Vendor'
                },
                {
                    label: 'WBS', value: 'WBS'
                },
            ],
            searchForItem: [],
            searchFor: new URLSearchParams(this.props.location.search).get("searchFor") ? new URLSearchParams(this.props.location.search).get("searchFor") : "",
            csvData: [],
            WBSCode: [],
            modalQAActivity: false,
        }
        this.unclaimPO = this.unclaimPO.bind(this);
        this.claimPO = this.claimPO.bind(this);
        this.handleDataLoading = this.handleDataLoading.bind(this);
        this.modal = this.modal.bind(this);
        this.handleClick = this.handleClick.bind(this);

    }



    componentDidMount() {
        this.handleDataLoading()
        this.getFilterList()
    }

    getFilterList = async () => {
        await this.props.GetFilterList()
        console.log(this.props.filterList, 'filterList')

        let finalvendorlist = []
        let finalpos = []
        let finalwbsno = []
        let finalplantcode = []
        let finalemployees = []
        let finalSupplierCategory = []
        await finalemployees.push({ label: `Open`, value: 'opened' })
        await this.props.filterList[5].map(async (item) => {
            await finalemployees.push({ label: `${item.EmployeeName}`, value: item.EmployeeName })
        })
        await this.props.filterList[1].map(async (item) => {
            await finalplantcode.push({ label: item.PlantCode, value: item.PlantCode })
        })
        await this.props.filterList[2].map(async (item) => {
            await finalwbsno.push({ label: (item.WBSCode).substring(0, 6), value: (item.WBSCode).substring(0, 6) })
        })
        await this.props.filterList[3].map(async (item) => {
            await finalvendorlist.push({ label: item.VendorName, value: item.VendorName })
        })
        await this.props.filterList[4].map(async (item) => {
            await finalpos.push({ label: item.POSAPId, value: item.POSAPId })
        })
        await this.props.filterList[8].map(async (item) => {
            await finalSupplierCategory.push({ label: item.SupplierCategory, value: item.SupplierCategory })
        })
        let POSAPId = []
        let WBSCode = []
        let PlantCode = []
        let VendorName = []
        let employees = []
        let supplierCategory = []
        let searchForItem = []
        await this.state.sortByPlantCode.map(async (item) => {
            await PlantCode.push({ label: item, value: item })
        })
        await this.state.sortByWBS.map(async (item) => {
            await WBSCode.push({ label: item, value: item })
        })
        await this.state.sortByPo.map(async (item) => {
            await POSAPId.push({ label: item, value: item })
        })
        await this.state.sortByVendor.map(async (item) => {
            await VendorName.push({ label: item, value: item })
        })
        await this.state.sortByEmployees.map(async (item) => {
            await employees.push({ label: item, value: item })
        })
        await this.state.sortBySupplierCategory.map(async (item) => {
            await supplierCategory.push({ label: item, value: item })
        })
        if (this.state.searchFor) {
            await searchForItem.push({ label: this.state.searchFor, value: this.state.searchFor })
        }
        await this.setState({ finalvendorlist, finalpos, finalwbsno, finalplantcode, finalemployees, PlantCode, WBSCode, POSAPId, VendorName, employees, supplierCategory, finalSupplierCategory, searchForItem })
    }

    handleDataLoading = async () => {
        let userId = AuthHandlerInstance.getUserID()
        let roles = this.state.roles
        if (roles[12]) {
            let sortByWBS = []
            let WBSCode = []
            await this.props.getProjectAllocationByUserId({ UserId: userId })
            let ProjectCodes = await this.props.poDetails.getProjectAllocationByUserId
            if (ProjectCodes.length > 0) {
                ProjectCodes.map((elem) => {
                    sortByWBS.push(elem.ProjectCode)
                    WBSCode.push({ label: elem.ProjectCode, value: elem.ProjectCode })
                })
            }
            await this.setState({ sortByWBS, WBSCode })
        }
        await this.filterData(this.state.currentPage)
        let role = 0
        if (roles[6]) {
            role = 6
        }
        if (roles[20]) {
            role = 20
        }
        if (roles[21]) {
            role = 21
        }
        if (roles[22]) {
            role = 22
        }
        if (roles[23]) {
            role = 23
        }
        if (roles[24]) {
            role = 24
        }
        let searchData = {
            currentPage: 1,
            posPerpage: this.state.totalPos,
            searchTerm: this.state.searchTerm,
            poStatus: 7,
            role: role,
            sortByEmployees: this.state.sortByEmployees,
            sortByPlantCode: this.state.sortByPlantCode,
            sortByWBS: this.state.sortByWBS,
            sortByPo: this.state.sortByPo,
            sortByVendor: this.state.sortByVendor,
            sortBySupplierCategory: this.state.sortBySupplierCategory,
            sortBy: this.state.sortBy,
            poDocStartDate: this.state.poDocStartDate,
            poDocEndDate: this.state.poDocEndDate,
            searchFor: this.state.searchFor,
        }
        // await this.setState({ loading: false})
        await this.props.getPOSearch(searchData)
        let csvData = []
        // await this.props.poDetails.poSearch.pos.map(async (data) => {
        //     let Projectcode = data.ProjectCode ? data.ProjectCode.includes('ET') ? (data.ProjectCode).slice(0, 11) : (data.ProjectCode).slice(0, 6) : ''
        //     await csvData.push({
        //         "POSAPId": data.POSAPId,
        //         "ProjectCode": Projectcode,
        //         "VendorSapId": data.VendorSapId,
        //         "VendorName": data.VendorName,
        //         "PO Date": data.POCreationDate ? dateFormater(data.POCreationDate) : '---',
        //         "PO Del. Date": data.PODeliveryDate ? dateFormater(data.PODeliveryDate) : '---',
        //         "PO Approved Date": data.PoApprovalDate ? dateFormater(data.PoApprovalDate) : '---',
        //         "Location": data.Location,
        //         "Hold": data.status,
        //         "Claimed By": data.Claimby,
        //         "Claimed Date": data.ClaimedDate ? dateFormater(data.ClaimedDate) : '---',
        //         "Vendor Category": data.SupplierCategory,
        //         "Currency": data.Currency,
        //         "PO Amount": data.POAmount,
        //         "Plant Code": data.PlantCode,
        //         "Purchase Group": data.PurchaseGroup,


        //     })
        // }) // to get the PO Data for download
        await this.setState({ csvData, loading: false })

    }

    handlepoDocStartDate = async (e) => {
        await this.setState({ poDocStartDate: e.target.value })
        await this.filterData()
    }
    handlepoDocEndDate = async (e) => {
        await this.setState({ poDocEndDate: e.target.value })
        await this.filterData()
    }

    filterData = async (currentPage = 1) => {
        await this.setState({ loading: true })
        let tableData = []
        let totalPos = 0
        let roles = this.state.roles
        let role = 0
        if (roles[6]) {
            role = 6
        }
        if (roles[20]) {
            role = 20
        }
        if (roles[21]) {
            role = 21
        }
        if (roles[22]) {
            role = 22
        }
        if (roles[23]) {
            role = 23
        }
        if (roles[24]) {
            role = 24
        }
        let searchData = {
            currentPage: currentPage,
            posPerpage: this.state.posPerpage,
            searchTerm: this.state.searchTerm,
            poStatus: 7,
            role: role,
            sortByEmployees: this.state.sortByEmployees,
            sortByPlantCode: this.state.sortByPlantCode,
            sortByWBS: this.state.sortByWBS,
            sortByPo: this.state.sortByPo,
            sortByVendor: this.state.sortByVendor,
            sortBySupplierCategory: this.state.sortBySupplierCategory,
            sortBy: this.state.sortBy,
            poDocStartDate: this.state.poDocStartDate,
            poDocEndDate: this.state.poDocEndDate,
            searchFor: this.state.searchFor,
        }

        this.props.history.push({
            pathname: '/QAplanningdashboard',
            search: "?" + new URLSearchParams(searchData).toString()
        })
        await this.props.getPOSearch(searchData)
        if (this.props.poDetails && this.props.poDetails.poSearch && 'pos' in this.props.poDetails.poSearch) {
            tableData = this.props.poDetails.poSearch.pos
            totalPos = this.props.poDetails.poSearch.pageinfo.totalcount
            console.log(this.props.poDetails.poSearch, "cvba")
        }
        await this.setState({ tableData, totalPos, currentPage: currentPage, loading: false })
    }

    // ? handle search input
    handleISearch = (e) => {

        let searchTerm = e.target.value

        this.setState({
            searchTerm
        })

        console.log(this.state.searchTerm)

    }


    handleSelectPoPerPage = async (e) => {
        await this.setState({ posPerpage: e.value })
        await this.filterData()
    }

    // ? handle searching
    handleSearching = async () => {
        await this.filterData(1)
    }

    handleSelectSearchFor = async (value) => {
        let searchFor = value
        let searchForItem = [
            {
                label: value, value: value
            }
        ]
        await this.setState({ searchFor, searchForItem })
    }

    modal = (poRowData) => {
        // this.setState({})
        // console.log(poRowData)
        this.setState({ selectedItem: poRowData })
        this.setState({ modal: !this.state.modal });

        if (this.state.modal === true) {
            this.setState(
                { opacity: "" }
            )

        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
            // this.setState({selectedItem:null})

        }
    }
    modalQAActivity = async (poRowData) => {
        // this.setState({})
        // console.log(poRowData)
        if (poRowData) {
            this.setState({ selectedItem: poRowData })
            await this.props.getQAActivity({
                PurchaseOrderId: poRowData.PurchaseOrderId
            })
        } else {
            this.setState({ selectedItem: {} })
        }
        this.setState({ modalQAActivity: !this.state.modalQAActivity });

        if (this.state.modalQAActivity === true) {
            this.setState(
                { opacity: "" }
            )

        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
            // this.setState({selectedItem:null})

        }
    }

    unClaimModal = (poRowData) => {
        // this.setState({})
        console.log(poRowData)
        this.setState({ selectedItem: poRowData })
        this.setState({ unClaimModal: !this.state.unClaimModal });

        if (this.state.unClaimModal === true) {
            this.setState(
                { opacity: "" }
            )

        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
            // this.setState({selectedItem:null})

        }
    }

    // ? claim PO function
    claimPO = async (poRowData) => {

        this.setState({ modal: !this.state.modal });
        var permissions = AuthHandlerInstance.getPermissions();
        let permissionId = 3;
        if (Array.isArray(permissions) && permissions.indexOf(4) > -1) {
            permissionId = 4;
        }
        var user = {
            userId: this.state.userId,
            permissionId: permissionId
        };

        swal("Claiming Purchase Order...", { button: false, icon: "info" })
        await this.props.postClaimPO(poRowData.PurchaseOrderId, user).then(resp => {
            console.log("resp", this.props.poDetails)
            if (this.props.poDetails.postClaimStatus.status) {
                swal("PO has been succesfully claimed!!", { button: true, icon: "success" })
            }
        }
        ).then(res => {
            console.log(res)
        })
        await this.filterData(this.state.currentPage)
        this.setState({ selectedItem: null });


        // window.location.reload()

    }


    // ? unclaim PO function
    unclaimPO = async (poRowData) => {


        console.log("roles 2", poRowData)

        console.log(this.state.selectedItem)
        this.setState({ unClaimModal: !this.state.unClaimModal });
        var user = {
            employeeId: poRowData.ClaimbyId,
            permissionId: 4
        }
        // alert("rowData ", poRowData.PurchaseOrderId, user)

        // ! to uncomment
        swal("Unlocking Purchase Order...", { button: false, icon: "info" })
        await this.props.postUnClaimPO(poRowData.PurchaseOrderId, user).then(resp => {
            console.log("resp", this.props.poDetails)
            if (this.props.poDetails.postUnClaimStatus.status) {
                swal("PO has been succesfully unlocked!!", { button: true, icon: "success" })
            }
        }
        ).then(res => {
            console.log(res)
        })

        await this.filterData(this.state.currentPage)
        this.setState({ selectedItem: null });

        // window.location.reload()

    }

    dateformate(dateVal) {
        let d = new Date(dateVal);
        return d.toDateString();
    }

    handleClick = async (event) => {
        let currentPage = Number(event.target.id)
        if (!event.target.id) {
            currentPage = event.target.offsetParent.id
        }
        await this.setState({ currentPage })
        await this.filterData(currentPage)
    }
    handleSelectPO = async (e) => {
        let sortByPo = []
        let POSAPId = []
        if (e.length > 0) {
            e.map((item) => {
                sortByPo.push(item.value)
                POSAPId.push(item)
                return item
            })
        }
        await this.setState({ sortByPo, POSAPId })
        await this.filterData()
    }
    handleSelectWBS = async (e) => {
        let sortByWBS = []
        let WBSCode = []
        if (e.length > 0) {
            e.map((item) => {
                sortByWBS.push(item.value)
                WBSCode.push(item)
                return item
            })
        }
        await this.setState({ sortByWBS, WBSCode })
        await this.filterData()
    }
    handleSelectLoc = async (e) => {
        let sortByLoc = []
        if (e.length > 0) {
            e.map((item) => {
                sortByLoc.push(item.value)
                return item
            })
        }
        await this.setState({ sortByLoc })
        // console.log(this.state.sortByLoc, "JJJJ")
    }

    handleSelectEmployees = async (e) => {
        let sortByEmployees = []
        let sortBy = 'all'
        let employees = []
        if (e.length > 0) {
            e.map((item) => {
                if (item.value !== 'opened') {
                    sortByEmployees.push(item.value)
                } else {
                    sortBy = 'opened'
                }
                employees.push(item)
                return item
            })
        }
        await this.setState({ sortByEmployees, employees, sortBy })
        await this.filterData()
    }

    handleSelectPlantCode = async (e) => {
        let sortByPlantCode = []
        let PlantCode = []
        if (e.length > 0) {
            e.map((item) => {
                sortByPlantCode.push(item.value)
                PlantCode.push(item)
                return item
            })
        }
        await this.setState({ sortByPlantCode, PlantCode })
        await this.filterData()
    }

    handleSelectVendor = async (e) => {
        let sortByVendor = []
        let VendorName = []
        console.log(e, "HHHH")
        if (e.length > 0) {
            e.map((item) => {
                sortByVendor.push(item.value)
                VendorName.push(item)
                return item
            })
        }
        await this.setState({ sortByVendor, VendorName })
        await this.filterData()
    }

    handleSelectSupplierCategory = async (e) => {
        let sortBySupplierCategory = []
        let supplierCategory = []
        console.log(e, "HHHH")
        if (e.length > 0) {
            e.map((item) => {
                sortBySupplierCategory.push(item.value)
                supplierCategory.push(item)
                return item
            })
        }
        await this.setState({ sortBySupplierCategory, supplierCategory })
        await this.filterData()
    }


    toggleFilter = async () => {
        this.setState({ isShowFilter: !this.state.isShowFilter })
    }
    togglePoDocDate = async () => {
        this.setState({ isShowPoDocDate: !this.state.isShowPoDocDate })
    }
    toggleDCDate = async () => {
        this.setState({ isShowDCDate: !this.state.isShowDCDate })
    }
    toggleStatDeliverDate = async () => {
        this.setState({ isShowStatDeliverDate: !this.state.isShowStatDeliverDate })
    }
    clearFilter = async () => {
        await this.setState({
            isShowFilter: false,
            currentPage: 1,
            posPerpage: 10,
            searchTerm: '',
            sortByEmployees: [],
            sortByPlantCode: [],
            sortByWBS: [],
            sortByPo: [],
            sortByVendor: [],
            sortBy: 'all',
            poDocStartDate: '',
            poDocEndDate: '',
            searchFor: '',
            POSAPId: [],
            WBSCode: [],
            PlantCode: [],
            VendorName: [],
            searchForItem: [],
            employees: [],
        })
        await this.filterData()
    }
    goToLocation = async (params) => {
        this.props.history.push({
            pathname: '/QAplanning',
            search: "?" + new URLSearchParams(params).toString()
        })

    }
    render() {

        console.log(this.props, "abc")
        console.log(this.state.tableData, "cvb")
        console.log(this.props.poDetails, 'abcde',)

        // stating pagination
        const { currentPage, posPerpage } = this.state;

        // Logic for displaying todos
        // const indexOfLastTodo = currentPage * posPerpage;
        // const indexOfFirstTodo = indexOfLastTodo - posPerpage;
        const filteredTodos = this.state.tableData;
        // const currentTodos = filterData.slice(indexOfFirstTodo, indexOfLastTodo);

        var roles = authInstance.getRoles()

        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                borderBottom: '1px dotted pink',
                //   color: state.isSelected ? 'red' : 'blue',
                padding: "2px 10px",
            }),
            menu: (provided, state) => ({
                ...provided,
                width: "100%",
                minWidth: "max-content",
                zIndex: "999 !important",
            }),
        }

        var permissions = AuthHandlerInstance.getPermissions()
        if (this.props.poDetails.loading) {
            return (
                <Loading />
            )

        }
        else {
            return (

                <div className="Container-fluid p-4 pageheight">
                    {/* ----------QA Activity Modal Start---------------- */}
                    <Modal isOpen={this.state.modalQAActivity} className="modal-xl mr-2">
                        <div className={"modal-bg" + (this.state.modalQAActivity === 'false' ? 'open' : '')}>
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header">
                                    <div><h4 >Activity Details : {this.state.selectedItem.POSAPId}</h4></div>
                                    <button type="button" className="close" aria-label="Close" onClick={() => this.modalQAActivity()} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>
                            <div >
                                <ModalBody Style="modal-body">
                                    <div className="row">
                                        <div className="col">
                                            <table border="1" className="table5 table" >
                                                <thead>
                                                    <tr className="headerbar ">
                                                        <th>Action</th>
                                                        <th>Acted By</th>
                                                        <th>Acted On</th>
                                                        <th>Acted Time</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.props.qaActivity && this.props.qaActivity.length > 0 && this.props.qaActivity.map((item, index) =>
                                                        <tr key={index} className="rows headeralign">
                                                            <td>{item.ActionName}</td>
                                                            <td>{item.UploadedBy}</td>
                                                            <td>{item.CreatedOn ? dateFormater(item.CreatedOn) : '----'}</td>
                                                            <td>{item.CreatedOn ? formatTime(item.CreatedOn) : '----'}</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </ModalBody>
                            </div>
                        </div>
                    </Modal>
                    {/* ----------QA Activity Modal End---------------- */}

                    {/* ------Modal for claim PO yes/No Start */}
                    <div className="row">
                        <Modal isOpen={this.state.modal} >
                            <div className={"modal-bg" + (this.state.modal === 'false' ? 'open' : '')}>
                                <div className="modalheads">
                                    <ModalHeader HeaderStyle="modal-header">
                                        <div className="modal-text"><h4 >PO Claim</h4></div>
                                        <button type="button" className="close" aria-label="Close" onClick={this.modal} >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </ModalHeader>
                                </div>
                                <div >
                                    <ModalBody >

                                        <div className="row text-center pb-2">
                                            <FontAwesomeIcon icon={'user-lock'} className="pt-4 submission-check-cirle pb-4" size="10x" />
                                        </div>

                                        <div className="row pt-4 p-4 modal-text text-centre">

                                            Are you sure you want to claim this PO?

                                        </div>
                                        {/* <div className="row ">
                            <button className="btn2 btn-sms1 mt-2  float-right" onClick={this.modal} type="submit">No</button>
                            <button className="btn2 btn-sms1 mt-2  float-right" onClick={this.modal} type="submit">Yes</button> 
                        </div> */}


                                    </ModalBody>
                                </div>
                                <div >
                                    <ModalFooter FooterStyle="modal-footer">


                                        <div>
                                            <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.modal} type="submit">No</button>
                                            <button className="btn2 btn-sms1 mt-2  float-right" onClick={() => this.claimPO(this.state.selectedItem)} type="submit">Yes</button>

                                        </div>




                                    </ModalFooter>
                                </div>
                            </div>
                        </Modal>
                    </div>

                    {/* ------Modal for claim PO yes/No End */}

                    {/* ------Modal for claim PO yes/No Start */}
                    <div className="row">
                        <Modal isOpen={this.state.unClaimModal} >
                            <div className={"modal-bg" + (this.state.unClaimModal === 'false' ? 'open' : '')}>
                                <div className="modalheads">
                                    <ModalHeader HeaderStyle="modal-header">
                                        <div className="modal-text"><h4 >PO Claim</h4></div>
                                        <button type="button" className="close" aria-label="Close" onClick={this.unClaimModal} >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </ModalHeader>
                                </div>
                                <div >
                                    <ModalBody >

                                        <div className="row text-center pb-2">
                                            <FontAwesomeIcon icon={'lock-open'} className="pt-4 submission-check-cirle pb-4" size="10x" />
                                        </div>

                                        <div className="row pt-4 p-4 modal-text text-centre">

                                            Are you sure you want to unlock this PO?

                                        </div>
                                        {/* <div className="row ">
                            <button className="btn2 btn-sms1 mt-2  float-right" onClick={this.modal} type="submit">No</button>
                            <button className="btn2 btn-sms1 mt-2  float-right" onClick={this.modal} type="submit">Yes</button> 
                        </div> */}


                                    </ModalBody>
                                </div>
                                <div >
                                    <ModalFooter FooterStyle="modal-footer">


                                        <div>
                                            <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.unClaimModal} type="submit">No</button>
                                            <button className="btn2 btn-sms1 mt-2  float-right" onClick={() => this.unclaimPO(this.state.selectedItem)} type="submit">Yes</button>

                                        </div>




                                    </ModalFooter>
                                </div>
                            </div>
                        </Modal>
                    </div>

                    {/* ------Modal for claim PO yes/No End */}

                    <div className="row justify-content-between">
                        <div className="col header">
                            <b>QA Planning Dashboard</b>
                        </div>

                        {/* <div className="col-md-6">
                                        <Link  to ={{ pathname: '/inspectiondashboard',state : {} }}> 
                                        <button className="btn2 btn-sms1 mr-4 float-right" type="submit"> Inspection Dashboard</button>
                                        </Link>
                                    </div>  */}
                        <div className='col pt-3'>
                            {/* <CSVLink className="btn2 btn-sms1 float-right rounded-pill" data={this.state.csvData} filename='QA-Dashboard'>export</CSVLink> */}

                        </div>
                        <div className="col-6 pt-3" style={{ paddingRight: 35 }}>
                            <SearchBar placeholder="Search" value={this.state.searchTerm} searchInputHandler={(e) => { this.handleISearch(e) }} searchClick={this.handleSearching} label="Search" toggleFilter={this.toggleFilter} clearFilter={this.clearFilter} filter={true} clear={true} btnName="" ShowSearchFor={true} searchForOptions={this.state.searchForOptions} searchForItem={this.state.searchForItem} SelectSearchForHandler={this.handleSelectSearchFor} />
                        </div>
                    </div>

                    {this.state.isShowFilter ?
                        <div className="row justify-content-between pb-3 pt-3 m-0 border-radius-modal border-color filter-data pr-2 pl-2">
                            <div className="col">
                                <Select maxMenuHeight={500} placeholder="Planner" isMulti value={this.state.employees} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalemployees} onChange={(e) => this.handleSelectEmployees(e)} />
                            </div>
                            <div className="col">
                                <Select maxMenuHeight={500} placeholder="Project Code" isMulti value={this.state.WBSCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalwbsno} onChange={(e) => this.handleSelectWBS(e)} />
                            </div>
                            <div className="col">
                                <Select maxMenuHeight={500} placeholder="Vendor" isMulti value={this.state.VendorName} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalvendorlist} onChange={(e) => this.handleSelectVendor(e)} />
                            </div>
                            <div className="col">
                                <Select maxMenuHeight={500} placeholder="Supplier Category" isMulti value={this.state.supplierCategory} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalSupplierCategory} onChange={(e) => this.handleSelectSupplierCategory(e)} />
                            </div>
                            <div className="col">
                                <Select maxMenuHeight={500} placeholder="Plant" isMulti value={this.state.PlantCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalplantcode} onChange={(e) => this.handleSelectPlantCode(e)} />
                            </div>
                            <div className="col">
                                <Select maxMenuHeight={500} placeholder="PO No." isMulti value={this.state.POSAPId} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalpos} onChange={(e) => this.handleSelectPO(e)} />
                            </div>
                            <div className="col">
                                <InputGroup>
                                    <FormControl className='outline-primary' type="text" readOnly placeholder="PO Dt." />
                                    <InputGroup.Append>
                                        <Button className="custom-drop-arrow" onClick={() => this.togglePoDocDate()} variant="outline-secondary"><FontAwesomeIcon icon={"chevron-down"} size="xs" /></Button>
                                    </InputGroup.Append>
                                </InputGroup>
                                {this.state.isShowPoDocDate ?
                                    <>
                                        <label>Start Date</label>
                                        <Form.Control className="width-90" type="date" onChange={(e) => { this.handlepoDocStartDate(e) }} placeholder="Start Date" value={this.state.poDocStartDate} />
                                        <label>End Date</label>
                                        <Form.Control className="width-90" type="date" onChange={(e) => { this.handlepoDocEndDate(e) }} id={`inspectionEndDate-datepicker`} name={`inspectionEndDate-datepicker`} placeholder="inspection End Date" value={this.state.poDocEndDate} />
                                    </>
                                    : null}
                            </div>
                        </div>
                        : null}

                    <div className="row sticky pt-2">
                        <div className="col-md-12 centre-alligned wrap">
                            <Table className="table1 text-left ">
                                <thead className=" sticky-inner">
                                    <tr >
                                        <th className="align-middle">PO Number</th>
                                        <th className="align-middle">Project Code</th>
                                        <th className="align-middle">Vendor</th>
                                        <th className="align-middle">PO Date</th>
                                        <th className="align-middle">PO Dl. Date</th>
                                        <th className="align-middle">PO App. Date</th>
                                        <th className="align-middle">Net Value</th>
                                        <th className="align-middle">Location</th>
                                        <th className="align-middle">Hold</th>
                                        {roles[6] || roles[20] || roles[21] || roles[22] || roles[23] || roles[24] ? null :
                                            <th className="align-middle">Claimed By</th>
                                        }
                                        <th className="align-middle">Actions</th>
                                        <th className="align-middle">Supplier Category</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {this.state.loading ?
                                        <Loading />
                                        :
                                        filteredTodos.map((item) => (
                                            // tableData.map((item, index)=>(
                                            <tr style={{ overflow: "hidden" }}>
                                                <td className="align-middle">{item.POSAPId}</td>
                                                <td className="align-middle">{item.ProjectCode ? (item.ProjectCode).substring(0, 6) : '--'}</td>
                                                <td className="align-middle">{item.VendorName}</td>
                                                <td className="align-middle text-center">{item.POCreationDate ? dateFormater(item.POCreationDate) : '----'}</td>
                                                <td className="align-middle text-center">{item.PODeliveryDate ? dateFormater(item.PODeliveryDate) : '----'}</td>
                                                <td className="align-middle text-center">{item.PoApprovalDate ? dateFormater(item.PoApprovalDate) : '----'}</td>
                                                <td className="align-middle amount-text">{numberWithCommas(item.POAmount)}</td>
                                                <td className="align-middle">{item.Location}</td>
                                                <td className="align-middle">{item.status}</td>
                                                {roles[6] || roles[20] || roles[21] || roles[22] || roles[23] || roles[24] ? null :
                                                    <td className="align-middle">{item.Claimby}</td>
                                                }
                                                <td>
                                                    <div className="row justify-content-md-center text-center p-2">
                                                        {item.PlantCode !== null ?
                                                            <div className="col-sm-4">
                                                                <FontAwesomeIcon onClick={() => this.goToLocation({ poID: item.PurchaseOrderId, Claimby: item.Claimby })} cursor={"pointer"} icon={"eye"} color={"black"} title="View" size="lg" />
                                                            </div>
                                                            : null}
                                                        <div className="col-sm-4">
                                                            {
                                                                permissions[3] || permissions[4] ?


                                                                    item.ClaimStatus ? (item.ClaimbyEmployeeID === this.state.employee.employeeId ? <FontAwesomeIcon icon={"user-lock"} title="PO claimed by me" cursor="pointer" color={"blue"} size="lg" onClick={roles[1] ? () => this.unClaimModal(item) : null} /> : <FontAwesomeIcon icon={"lock"} title={"PO Claimed by " + item.Claimby} size="lg" cursor="pointer" onClick={roles[1] ? () => this.unClaimModal(item) : null} />) :
                                                                        < FontAwesomeIcon icon={"lock-open"} cursor="pointer" color={"black"} title="Claim PO" size="lg" onClick={() => this.modal(item)} />

                                                                    : null
                                                            }
                                                        </div>
                                                        <div className="col-sm-4">
                                                            < FontAwesomeIcon icon={"info-circle"} cursor="pointer" color={"black"} title="View Info" size="lg" onClick={() => this.modalQAActivity(item)} />
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="align-middle">{item.SupplierCategory ? item.SupplierCategory : '---'

                                                }</td>
                                            </tr>
                                        ))}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                    <div className="float-right">
                        <hr></hr>
                        <PaginationComponent filteredTodos={filteredTodos} currentPage={currentPage} posPerpage={posPerpage} totalPos={this.state.totalPos} handleClick={this.handleClick} handleSelectPoPerPage={this.handleSelectPoPerPage} showPosPerpage={true} />
                        <hr></hr>
                    </div>
                </div>

            )
        }
    }
}



const mapStateToProps = (state) => ({
    poDetails: state.poDetails,
    qaActivity: state.poDetails.qaActivity,
    filterList: state.masterReducer.filterList
})
export default connect(mapStateToProps, { getPODetails, getPOSearch, postClaimPO, postUnClaimPO, getSearchedPO, GetFilterList, GetExcellExportData, getProjectAllocationByUserId, getQAActivity })(Dashboard)
